// extracted by mini-css-extract-plugin
module.exports = {"commentsAction":"Industry_commentsAction__25Esi","messageIcon":"Industry_messageIcon__dQQm9","commentText":"Industry_commentText__31lSG"};